
import { BaseEntity } from "yt-ng-framework";

export class KomitentUgovorView extends BaseEntity{
    constructor(){
        super();
    }

    PodvrstaDokumentaStavkaNaziv: string = null;
    KomitentNaziv: string = null;
    BrojDokumenta: string = null;
    Datum: Date = null;
    OdDatuma: Date = null;
    DoDatuma: Date = null;
    BrojDokumenta2: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.PodvrstaDokumentaStavkaNaziv = input.PodvrstaDokumentaStavkaNaziv;
        this.KomitentNaziv = input.KomitentNaziv;
        this.BrojDokumenta = input.BrojDokumenta;
        this.Datum = input.Datum;
        this.OdDatuma = input.OdDatuma;
        this.DoDatuma = input.DoDatuma;
        this.BrojDokumenta2 = input.BrojDokumenta2;
        return this; 
    }

    Serialize(input: KomitentUgovorView) {
        return input;
    }


}